const {component} = require('./ProductWidgetAppConfig');

module.exports = {
  default: {
    component,
  },
};
